module.exports = __webpack_public_path__ + "static/assets/bcc5680fcc652e46a3e707f2d63111f2.jpg";